import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/create/layer.create.mutation.gql"
import type {
  LayerCreateMutation,
  LayerCreateMutationVariables,
} from "@/v2-backoffice-client/layer/create/__types__/layer.create.mutation"

type Options = MutationHookOptions<
  LayerCreateMutation,
  LayerCreateMutationVariables
>

export function useLayerCreateMutation(options?: Options) {
  return useMutation<LayerCreateMutation, LayerCreateMutationVariables>(
    mutation,
    options,
  )
}
